<!--  -->
<template>
  <div class="details">
    <Header class="header" title="审批" :isRightIcon="isRightIcon" @closeBtn="$emit('closeBtn')" />
    <div class="details-card">
      <div class="details-header">
        <div class="header-left">{{ data.eventTitle }}</div>
        <div class="header-right" @click="$emit('seeDetails')">查看详情></div>
      </div>
      <div class="event-describe">
        <div>事发门店: {{ data.storeName }}</div>
        <div>事发时间: {{ data.happenTime | setDate }}</div>
        <template v-for="item in data.eventItems">
          <div :key="item.id" v-if="item.name != '事件详情'">{{item.name}}: {{ item.scoreContent }}</div>
        </template>
        
        <!-- <div>风险类别:{{ data.eventItems[1].scoreContent }}</div>
        <div>风险级别:{{ data.eventItems[2].scoreContent }}</div> -->
      </div>
      <template v-if="data.eventFollowUps.length != 0">
        <div class="processing-results">
          处理结果: {{ data.eventFollowUps[0].memo }}
        </div>
        <ImgList :images="imgList" class="imageList" />
      </template>
    </div>
    <approval-flow-chart
      v-if="data.flow && data.flow.length"
      :flowData="data.flow"
    />
  </div>
</template>

<script>
import Header from "./header.vue";
import ApprovalFlowChart from "../../../components/approvalFlowChart/approvalFlowChart.vue";
import ImgList from "../../../components/imgList";
import moment from "moment"
export default {
  props: ["data","isRightIcon"],
  components: {
    Header,
    ApprovalFlowChart,
    ImgList,
  },
  computed: {
    imgList() {
      if (this.data.eventFollowUps[0].appendix.length) {
        return this.data.eventFollowUps[0].appendix;
      }
      return [];
    }
  },
  filters: {
    setDate(val) {
      return moment(val).format("YYYY-MM-DD HH:mm:ss");
    }
  }
};
</script>
<style lang='less' scoped>
.details {
  background-color: #f4f5f7;
  width: 100%;
  height: 100%;
}
.details-card {
  background: #ffffff;
  box-shadow: 0px 3px 3px 0px rgba(227, 235, 255, 0.3);
  border-radius: 20px;
  border: 2px solid #e7f1fe;
  overflow: hidden;
  margin: 15px;
}
.details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #202636;
  background: linear-gradient(180deg, #ffffff 0%, #fafbfb 100%);
  padding: 13px 11px;
  .header-left {
    width: 225px;
  }
  .header-right {
    font-size: 14px;
    font-weight: 400;
    color: #74879b;
  }
}
.event-describe {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4a5462;
  background-color: #fff;
  // background-color: red;
  padding: 12px;
  border: 1px solid #edeff5;
}
.processing-results {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #202636;
  padding: 12px 12px 0 12px;
  word-break:break-all;
}
.imageList {
  padding: 12px;
}
</style>